import { requestWithToken } from '../utilities/request';
import * as _ from 'lodash';

const list = param => {
  return requestWithToken({
    method: 'GET',
    url: '/api/private/agency_registration_applications/companies',
    params: param,
  });
};

const toFormData = params => {
  const formData = new FormData();
  _.each(params, (value, column) => {
    if (_.isNil(value)) {
      return;
    }

    if (value instanceof Blob && value.name) {
      // blobでnameがある場合はappendにnameを追加 サーバ側でファイル名が取れるように
      formData.append(column, value, value.name);
    } else if (_.isArray(value)) {
      value.forEach(v => {
        formData.append(`${column}[]`, v); // arrayデータを分割して入れ直す
      });
    } else {
      formData.append(column, value);
    }
  });

  return formData;
};

const create = ({
  company_agent_to,
  company_agent_to_users,
  memorandum_file,
  status,
  parent_id = undefined,
}) => {
  const formData = toFormData({
    company_agent_to,
    company_agent_to_users,
    memorandum_file,
    status,
    parent_id,
  });
  return requestWithToken({
    method: 'POST',
    url: '/api/private/agency_registration_applications',
    processData: false,
    data: formData,
  });
};

const update = (
  id,
  {
    company_agent_to,
    company_agent_to_users,
    memorandum_file,
    memorandum_no_change,
    status,
  }
) => {
  const formData = toFormData({
    company_agent_to,
    company_agent_to_users,
    memorandum_file,
    memorandum_no_change,
    status,
  });
  return requestWithToken({
    method: 'PATCH',
    url: `/api/private/agency_registration_applications/${id}`,
    processData: false,
    data: formData,
  });
};

const del = id => {
  return requestWithToken({
    method: 'DELETE',
    url: `api/private/agency_registration_applications/${id}`,
  });
};

const show = id => {
  return requestWithToken({
    method: 'GET',
    url: `api/private/agency_registration_applications/${id}`,
  });
};

const downloadFile = id => {
  return requestWithToken({
    method: 'GET',
    url: `api/private/agency_registration_applications/${id}/download_file`,
  });
};

const checkDuplicate = company_agent_to => {
  return requestWithToken({
    method: 'GET',
    url: `api/private/agency_registration_applications/check_duplicate`,
    params: { company_agent_to },
  });
};

const otherAgenciesCount = company_agent_to => {
  return requestWithToken({
    method: 'GET',
    url: `api/private/agency_registration_applications/other_agencies_count`,
    params: { company_agent_to },
  });
};

const downloadTemplate = type => {
  return requestWithToken({
    method: 'GET',
    url: `api/private/agency_registration_applications/download_template`,
    params: { type },
    responseType: 'blob',
  });
};

const revoke = param => {
  return requestWithToken({
    method: 'PATCH',
    url: '/api/private/agency_registration_applications/revoke',
    params: param,
  });
};

const revokeAgentOrigin = param => {
  return requestWithToken({
    method: 'PATCH',
    url: '/api/private/agency_registration_applications/revoke_agent_origin',
    params: param,
  });
};

const history = param => {
  return requestWithToken({
    method: 'GET',
    url: '/api/private/agency_registration_applications/',
    params: param,
  });
};

const AgencyRegistrationApplicationService = {
  list,
  create,
  show,
  update,
  del,
  downloadFile,
  checkDuplicate,
  otherAgenciesCount,
  downloadTemplate,
  revoke,
  revokeAgentOrigin,
  history,
};
export default AgencyRegistrationApplicationService;



// WEBPACK FOOTER //
// ./src/services/AgencyRegistrationApplications.js